export default {
  data() {
    return {
      periods: [
        {
          period_type_id: 1,
          name: this.$t('common.min'),
          fullName: this.$t('common.min_full'),
          maxLength: 3,
          maxVal: 999
        },
        {
          period_type_id: 2,
          name: this.$t('common.days'),
          fullName: this.$t('common.days_full'),
          maxLength: 2,
          maxVal: 27
        },
        {
          period_type_id: 3,
          name: this.$t('common.mon'),
          fullName: this.$t('common.mon_full'),
          maxLength: 2,
          maxVal: 24
        }
      ]
    }
  }
}
